"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserWalletTransactionForAdminEntity = void 0;
const class_transformer_1 = require("class-transformer");
class UserWalletTransactionForAdminEntity {
    id;
    data;
    ref;
    amount;
    currency;
    type;
    reason;
    status;
    wallet;
    walletOwner;
    display;
    // TODO: cambiar
    reaction;
    // TODO: cambiar
    gif;
    // TODO: cambiar
    advertisment;
    // TODO: cambiar
    overlay;
    media;
    user;
    campaign;
    gateway;
    /**
     * Id of the payment gateway transaction
     */
    paymentGatewayTxId;
    /**
     * @deprecated
     */
    update_at;
    /**
     * @deprecated
     */
    create_at;
    createdAt;
    updatedAt;
}
exports.UserWalletTransactionForAdminEntity = UserWalletTransactionForAdminEntity;
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Date)
], UserWalletTransactionForAdminEntity.prototype, "update_at", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Date)
], UserWalletTransactionForAdminEntity.prototype, "create_at", void 0);
